import { useSupabaseLoader } from "../../../server/supabase/hooks";
import { fromISO8601 } from "../../../utils/iso8601";
import { SupabaseMomentLogService } from "../server/supabase-moment-log-service";

import type { UUID } from "../../../utils/uuid";
import type { MomentLogRecord } from "../server/supabase-moment-log-service";

export function useMomentLog(id: UUID): ReturnType<typeof useSupabaseLoader<MomentLogRecord[]>> {
  return useSupabaseLoader(
    async ({ supabase, account_id }) => {
      const { data, error } = await new SupabaseMomentLogService(supabase).getAll(account_id, {
        order: [{ column: "created_at", dir: "asc" }],
        filter: [{ key: "moment_id", operator: "eq", value: id }],
      });

      if (error) throw error;

      // Filter messages with the same action that occur within 1 minute of each other
      return data
        .reduce<MomentLogRecord[]>((acc, curr) => {
          const last = acc[acc.length - 1];

          if (last && last.action === curr.action && last.user_name === curr.user_name) {
            const lastDate = fromISO8601(last.created_at);
            const currDate = fromISO8601(curr.created_at);

            if (currDate.getTime() - lastDate.getTime() < 60 * 1000) return acc;
          }

          acc.push(curr);
          return acc;
        }, [])
        .toReversed();
    },
    [id],
  );
}
